import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import amplitude from 'amplitude-js';
import smartlookClient from 'smartlook-client';
import Icon from '../../../components/Icon';
import AppModal from '../../../components/Modal';
export const withAutoFixModal = (WrappedComponent) => withTranslation()(class AutoFixModal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
            files: [],
            issuesCount: 0,
            expanded: false,
            generatedPathsCopied: false,
            extension: '',
        };
        this.handleToggleExpanded = (event) => {
            if (event) {
                event.preventDefault();
            }
            this.setState((prevState) => {
                return {
                    expanded: !prevState.expanded,
                };
            });
        };
        this.handleCloseModal = () => {
            this.setState({
                open: false,
            });
        };
        this.handleClick = (files, issuesCount, extension) => {
            this.setState({
                open: true,
                files: files,
                issuesCount: issuesCount,
                extension: String(extension),
            });
            const eventName = 'show-quick-fixes-modal';
            const eventProperties = {
                files: files.length,
                issuesCount: issuesCount,
            };
            amplitude.getInstance().logEvent(eventName, eventProperties);
            smartlookClient.track(eventName, eventProperties);
        };
    }
    renderModal() {
        const { t } = this.props;
        const { generatedPathsCopied, extension, expanded, files } = this.state;
        const LIMIT = 10;
        let paths = [];
        let pathsToString = [].concat.apply([], files).join('\n');
        const pathCount = files.reduce((acc, file) => acc + file.length, 0);
        const ignoreFiles = {
            js: '.eslintignore',
            php: '.codesizeignore',
        };
        return (_jsxs(Modal, { isOpen: true, toggle: this.handleCloseModal, autoFocus: false, children: [_jsx(ModalHeader, { toggle: this.handleCloseModal, children: t('autoFixes', {
                        issuesCount: new Intl.NumberFormat(t('numberFormatLocale')).format(this.state.issuesCount),
                    }) }), _jsxs(ModalBody, { children: [_jsx("p", { children: t('autoFixBestPractises') }), _jsxs("p", { children: [t('ignoreFileHint'), ' ', _jsx("code", { children: this.state.extension &&
                                        Object.prototype.hasOwnProperty.call(ignoreFiles, extension)
                                        ? ignoreFiles[extension]
                                        : '' }), ' ', t('file'), ":"] }), _jsxs("div", { className: "code-auto-fix", children: [_jsxs("span", { className: "float-right", children: [!generatedPathsCopied ? null : _jsx("small", { className: "text-muted", children: t('copied') }), _jsx(CopyToClipboard, { className: "ml-2 cursor--pointer", text: pathsToString, title: t('copyToClipboard'), onCopy: () => {
                                                this.setState({ generatedPathsCopied: true });
                                                const eventName = 'quick-fixes-copied';
                                                amplitude.getInstance().logEvent(eventName);
                                                smartlookClient.track(eventName, {});
                                            }, children: _jsx(Icon, { name: "copy" }) })] }), _jsxs("figure", { children: [_jsx("figcaption", { children: extension &&
                                                Object.prototype.hasOwnProperty.call(ignoreFiles, extension)
                                                ? ignoreFiles[extension]
                                                : '' }), _jsx("pre", { className: clsx(!expanded && pathCount > LIMIT && 'paths'), children: files.map((file) => [
                                                // @ts-expect-error TS2322: Type string is not assignable to type any[]
                                                (paths = expanded ? file : file.slice(0, LIMIT)),
                                                paths.map((path) => (_jsxs("span", { children: [_jsx("code", { children: path }), _jsx("br", {})] }, path))),
                                            ]) })] }), this.state.expanded || pathCount < LIMIT ? null : (_jsx("div", { className: "btn-wrapper text-center", children: _jsx(Button, { color: "secondary", size: "md", onClick: this.handleToggleExpanded, children: t('showRemainingFilePath', { count: pathCount - LIMIT }) }) }))] })] })] }));
    }
    render() {
        return (_jsxs(React.Fragment, { children: [_jsx(WrappedComponent, { ...this.props, onShowDetailClick: this.handleClick }), !this.state.open ? null : _jsx(AppModal, { children: this.renderModal() })] }));
    }
});
